<template>
  <div ref="profilePreviewRef">
    <router-link :to="`/artist/${artwork?.userId?._id}`">
      <div class="flex items-center space-x-2">
        <BaseImage
          @contextmenu.prevent
          @dragstart.prevent
          v-if="artwork?.userId?.avatar"
          :uri="artwork?.userId?.avatar"
          img-class="size-8 min-w-8 rounded-full object-cover"
          :alt="
            `${artwork?.userId?.name || ''} ${artwork?.userId?.last_name || ''}` ||
            'Medium.am user'
          "
        />
        <div
          class="size-8 min-w-8 rounded-full flex items-center justify-center bg-primary/5 text-primary font-medium text-xs"
          v-else
        >
          {{ getInitials(artwork?.userId?.name, artwork?.userId?.last_name) }}
        </div>
        <div class="flex flex-col">
          <p class="text-sm font-medium">
            {{ artwork.userId.name }} {{ artwork.userId.last_name }}
          </p>
        </div>
      </div>
    </router-link>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { onClickOutside } from "@vueuse/core";
import type { Artwork } from "~~/types/artwork";
import { useWindowSize } from "@vueuse/core";

defineProps<{
  artwork: Artwork;
}>();

const { width } = useWindowSize();
const profilePreviewRef = ref<HTMLElement | null>(null);
const showPopup = ref<boolean>(false);

const toggleArtistPopup = (): void => {
  showPopup.value = !showPopup.value;
};
onClickOutside(profilePreviewRef, () => (showPopup.value = false));
</script>
